import { ref } from "vue";
import { store } from "../store";
import ResponseService from "./response.service";

import { ErrorNotifi, SuccessNotifi } from "../_helpers/notification";

const titleResult = ref({Success : false, Data: null});
const routePrefix = ref("title/");

const list = async () => {

    store.Loading = true;

    const { get, responseResult } = ResponseService();

    await get(routePrefix.value + "list");

    if(responseResult.value)
    {
        if (responseResult.value.Messages.filter(x => x.MessageId == 1).length > 0) {
            titleResult.value.Success = true;
            titleResult.value.Data = [{ Id: 0, Name: "Seçiniz" }, ...responseResult.value.Data];
        }
        else {
            let Messages = responseResult.value.Messages.filter(x => x.MessageId == 0);
            if (Messages.length > 0)
                ErrorNotifi(Messages[0].Message);

                titleResult.value.Success = false;
        }

        store.Loading = false;
    }
}

const dropdownList = async () => {

    const { get, responseResult } = ResponseService();

    await get(routePrefix.value + "list");

    if(responseResult.value)
    {
        if (responseResult.value.Messages.filter(x => x.MessageId == 1).length > 0) {
            titleResult.value.Success = true;
            titleResult.value.Data = [{ Id: 0, Name: "Seçiniz" }, ...responseResult.value.Data]
        }
        else {
            let Messages = responseResult.value.Messages.filter(x => x.MessageId == 0);
            if (Messages.length > 0)
                ErrorNotifi(Messages[0].Message);

                titleResult.value.Success = false;
        }
    }
}

const TitleService = () => {
    return { list, dropdownList, titleResult }
}

export default TitleService